import { AccessTime, CalendarMonth, EventAvailable } from "@mui/icons-material";
import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import AppConsole from './../../../components/console/console';
import { useStyles } from "./styles";

const typeOptions = [
  {
    id: "apply",
    value: "Apply",
  },
  {
    id: "destroy",
    value: "Destroy",
  },
];

const actionOptions = [
  {
    id: "plan",
    value: "Plan",
  },
  {
    id: "execution",
    value: "Execution",
  },
];

export default function ProvisionLog({ data }) {
  const classes = useStyles();
  const [selected, setSelected] = useState({
    type: typeOptions[data?.destroy ? 1 : 0],
    action:
      actionOptions[
        data?.[typeOptions[data?.destroy ? 1 : 0].id]?.execution ? 1 : 0
      ],
  });
  const [state, setState] = useState(
    data?.[selected?.type?.id]?.[selected?.action?.id]
  );

  const handleChange = (key, value) => {
    setSelected((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const allStatus = (TFData) => [
    {
      label: "Started",
      value: TFData?.startTime
        ? new Date(TFData?.startTime).toLocaleString()
        : "",
      icon: <CalendarMonth />,
    },
    {
      label: "Ended",
      value: TFData?.endTime ? new Date(TFData?.endTime).toLocaleString() : "",
      icon: <EventAvailable />,
    },
    {
      label: "Duration",
      value: TFData?.duration || "",
      icon: <AccessTime />,
    },
  ];

  useEffect(() => {
    setState(data?.[selected?.type?.id]?.[selected?.action?.id]);
    //eslint-disable-next-line
  }, [selected]);

  return (
    <Box className={classes.planRoot}>
      <Box className={classes.gridView}>
        {allStatus(state).map((status) => {
          return (
            status?.value && (
              <Box display="flex" alignItems="center" key={status.label}>
                {status.icon}
                <Typography
                  ml={1}
                  variant="body2"
                >{`${status.label} ${status.value}`}</Typography>
              </Box>
            )
          );
        })}
        <Box display={"flex"} sx={{ marginLeft: "auto" }}>
          <Autocomplete
            sx={{ minWidth: 200, marginRight: 2 }}
            clearIcon={false}
            options={typeOptions}
            value={selected?.type || ""}
            onChange={(e, value) => {
              handleChange("type", value);
            }}
            getOptionLabel={(option) => option.value}
            renderInput={(params) => (
              <TextField {...params} margin="normal" label="" />
            )}
          />
          <Autocomplete
            sx={{ minWidth: 200 }}
            clearIcon={false}
            options={actionOptions}
            value={selected?.action || ""}
            onChange={(e, value) => {
              handleChange("action", value);
            }}
            getOptionLabel={(option) => option.value}
            renderInput={(params) => (
              <TextField {...params} margin="normal" label="" />
            )}
          />
        </Box>
      </Box>
      <Box mt={3}>
        <AppConsole logs={state?.logs || ["No logs available"]} />
      </Box>
    </Box>
  );
}
